// conexiones
import Servers from './urlServers';
import './varsGlobals';
import { applyRetryInterceptor } from './axiosRetryInterceptor';
import axios from 'axios';
let host = Servers;
let cnx = 'test'; // valores = produccion | test | dev
window.urlmaster = host.urlmaster[cnx];
window.urlproject = host.urlproject[cnx];
window.urlbilling = host.urlbilling[cnx];
window.urldashboard = host.urldashboard[cnx];
window.urlbaselogin = host.urlbaselogin[cnx];
window.urlbase = host.urlbase[cnx];
window.urlweb = host.urlweb[cnx];
window.urlSlabs = host.urlSlabs[cnx];
window.urlDisplay = host.urlDisplay[cnx];
window.urlbSite = host.urlbSite[cnx];
window.urlbSales = host.urlbSales[cnx];

window.masterApiv2 = axios.create({
  baseURL: window.urlmaster + 'api/v2/'
});

window.master = axios.create({
  baseURL: window.urlmaster + 'api/v3/',
  headers: {
    common: {
      Authorization: 'Bearer ' + window.localtoken_M
    },
    post: { 'Content-Type': 'application/json' }
  }
});
window.masterGetBilling = axios.create({
  baseURL: window.urlmaster + 'api/getBilling/',
  headers: {
    common: {
      Authorization: 'Bearer ' + window.localtoken_M
    },
    post: { 'Content-Type': 'application/json' }
  }
});
window.project = axios.create({
  baseURL: window.urlproject + 'api/v3/',
  headers: {
    common: {
      Authorization: 'Bearer ' + window.localtoken_P
    },
    post: { 'Content-Type': 'application/json' }
  }
});
window.SlabsV2 = axios.create({
  baseURL: window.urlSlabs + 'api/v2/'
});
window.Slabs = axios.create({
  baseURL: window.urlSlabs + 'api/v3/',
  headers: {
    common: {
      Authorization: 'Bearer ' + window.localtoken_slabs
    },
    post: { 'Content-Type': 'application/json' }
  }
});
window.projectV2 = axios.create({
  baseURL: window.urlproject + 'api/v2/'
});

window.apiv2 = axios.create({
  baseURL: window.urlbilling + 'api/v2/'
});
window.billing = axios.create({
  baseURL: window.urlbilling + 'api/v3/',
  headers: {
    common: {
      Authorization: 'Bearer ' + window.localtoken,
      oauthB: localStorage.getItem('oauth'),
      orgID: localStorage.getItem('mark_client_data')
    },
    post: { 'Content-Type': 'application/json' }
  }
});

window.billingMP = axios.create({
  baseURL: window.urlbilling + 'api/MP/',
  headers: {
    common: {
      Authorization: 'Bearer '
    },
    post: { 'Content-Type': 'application/json' }
  }
});

window.reselleR1 = axios.create({
  baseURL: window.urlmaster + 'api/r1/'
});
window.reselleR2 = axios.create({
  baseURL: window.urlmaster + 'api/r2',
  headers: {
    common: {
      Authorization: 'Bearer ' + window.localtoken_r,
      oauth_r: localStorage.getItem('oauth_r'),
    },
    post: { 'Content-Type': 'application/json' }
  }
});

window.billingSales = axios.create({
  baseURL: window.urlbilling + 'api/sales/',
  headers: {
    common: {
      Authorization: 'Bearer '
    },
    post: { 'Content-Type': 'application/json' }
  }
});
// interceptor de errores de axios

// Aplica el interceptor reutilizable
// 3 reintentos por defecto
applyRetryInterceptor(window.masterApiv2, 3);
applyRetryInterceptor(window.master, 3);
applyRetryInterceptor(window.masterGetBilling, 3);
applyRetryInterceptor(window.project, 3);
applyRetryInterceptor(window.SlabsV2, 3);
applyRetryInterceptor(window.Slabs, 3);
applyRetryInterceptor(window.projectV2, 3);
applyRetryInterceptor(window.apiv2, 3);
applyRetryInterceptor(window.billing, 3);
applyRetryInterceptor(window.billingMP, 3);
applyRetryInterceptor(window.reselleR1, 3);
applyRetryInterceptor(window.reselleR2, 3);
applyRetryInterceptor(window.billingSales, 3);
// verificar si hay metodos fallidos de envio y reintentar al iniciar el sistema
(function checkLastFailedRequest() {
  const saved = localStorage.getItem('lastFailedRequest');
  if (!saved) return;

  try {
    const request = JSON.parse(saved);

    const message = `We detected a previously failed operation with unsent data.
Would you like to retry sending it?

(ES) Detectamos una operación fallida previamente con datos sin enviar.
¿Desea volver a intentarlo?`;

    if (window.confirm(message)) {
      // Intenta reenviar automáticamente usando axios
      axios({
        method: request.method || 'post',
        url: request.url,
        data: request.data,
        params: request.params,
        headers: request.headers
      })
        .then(response => {
          alert(`Request resent successfully! ✅

(ES) ¡La solicitud se reenvío con éxito! ✅`);
          localStorage.removeItem('lastFailedRequest');
        })
        .catch(error => {
          alert(`Failed to resend the request. ❌

(ES) No se pudo reenviar la solicitud. ❌`);
          console.error(error);
        });
    } else {
      // Si el usuario no quiere reenviar, eliminar los datos
      localStorage.removeItem('lastFailedRequest');
    }
  } catch (e) {
    console.warn('Error parsing last failed request:', e);
    localStorage.removeItem('lastFailedRequest'); // Limpieza por seguridad
  }
})();
